module.exports = __webpack_public_path__ + "assets/img/C1.4993603b.png";